import React, { MouseEventHandler, ReactNode } from 'react';
import { SxProps } from '@cp/ds';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { Typography } from '@cp/ds/src/components/typography';
import { StyledListItem } from '@cp/ds/src/components/styled/styledListItem';

export type ClientContactItemProps = {
  icon: ReactNode;
  label: ReactNode | ReactNode[];
  href?: string;
  component?: (props: { sx?: SxProps }) => JSX.Element | null;
  sx?: SxProps;
  onClick?: MouseEventHandler;
};

export const ClientContact: React.FC<ClientContactItemProps> = ({ onClick, href, icon, component = StyledListItem, sx, label }) => {
  const Component = component;
  return (
    <Component sx={mergeSx({ display: 'flex', alignItems: 'center' }, sx)}>
      {icon}
      <Typography
        component={href ? 'a' : 'span'}
        onClick={onClick}
        sx={{ ml: 2.5, cursor: 'pointer', color: 'inherit' }}
        variant="button"
        {...(href
          ? {
              href,
              rel: 'noreferrer',
              target: '_blank',
            }
          : undefined)}
      >
        {label}
      </Typography>
    </Component>
  );
};
